module.exports = __webpack_public_path__ + "media/images/firsttime_header02_sp-dc089131f46ff661f694146f49d17c43.png";